export const schema = {
    "": [
        {
            id : "licenseeIncharge",
            question : "Licensee in charge:",
            type : "text"
        },
        {
            id : "partisOfBusinessResponsibleFor",
            question : "Partis of Business Responsible For:",
            type : "text"
        },
        {
            id : "trusAccountResponsibleFor",
            question : "Trus Account/s Responsible For:",
            type : "text"
        },
        {
            id: "HYFRF-1",
            question: "Are records kept of all transactions?",
        },
        {
            id: "HYFRF-2",
            question: "Are all records kept for three years?",
        },
        {
            id: "HYFRF-3",
            question: "Are records in English?",
        },
        {
            id: "HYFRF-4",
            question:
                "Are all records kept at the registered office of the Licensee in charge in a safe storage facility?",
        },
        {
            id: "HYFRF-5",
            question:
                "Is an annual review of record keeping requirements diarised and a reminder triggered to action the review? (Yes _I-comply)",
        },
    ],

    "General agency records (please tick if complete and up to date)": [
        {
            id: "GAR-1",
            question: "Principal Licensee Declaration",
        },
        {
            id: "GAR-2",
            question: "Principal License Checklist",
        },
        {
            id: "GAR-3",
            question: "Licensee in charge Appointment Form",
        },
        {
            id: "GAR-4",
            question: "Licensee in charge Register",
        },
        {
            id: "GAR-5",
            question: "Staff CPD Register",
        },
        {
            id: "GAR-6",
            question: "Staff Reconciliation on Website",
        },
        {
            id: "GAR-7",
            question: "Complaints Register",
        },
        {
            id: "GAR-8",
            question: "Gifts and Benefits Register",
        },
        {
            id: "GAR-9",
            question: "Are there any instances of non-compliance?",
        },
        {
            id: "detailsOfNonCompliance",
            question: "Details of non-compliance (if relevant):",
            type : "longtext"
        },
    ],

    "Sales files": [
        {
            id: "SF",
            question: "Does every property for sale have a separate file?",
        },
    ],

    "SALES FILE #1" : [
        {
            id: `SF1-1`,
            question: "File number",
        },
        {
            id: `SF1-2`,
            question: "Vendor's name",
        },
        {
            id: `SF1-3`,
            question: "Vendor's contact details",
        },
        {
            id: `SF1-4`,
            question: "Property sold",
        },
        {
            id: `SF1-5`,
            question: "Copy of Agency Agreement",
        },
        {
            id: `SF1-6`,
            question: "Start date of Agency Agreement",
        },
        {
            id: `SF1-7`,
            question: "Expiry date of Agency Agreement",
        },
        {
            id: `SF1-8`,
            question: "Additional listing records (if required)",
        },
        {
            id: `SF1-9`,
            question: "Estimated Selling Price (including Estimated Selling Price Checklist and relevant information in support)",
        },
        {
            id: `SF1-10`,
            question: "Revised Estimated Selling Price (if reviewed)",
        },
        {
            id: `SF1-11`,
            question: "Any Vendor instructions not to disclose the Estimated Selling Price",
        },
        {
            id: `SF1-12`,
            question: "Weekly Vendor report (or as agreed by vendor)",
        },
        {
            id: `SF1-13`,
            question: "Relevant correspondence",
        },
        {
            id: `SF1-14`,
            question: "Price statements (verbally or in writing) made to prospective Purchasers",
        },
        {
            id: `SF1-15`,
            question: "Approved marketing and advertisements (including the Adverting and Marketing Checklist)",
        },
        {
            id: `SF1-16`,
            question: "Purchaser's name",
        },
        {
            id: `SF1-17`,
            question: "Purchaser's contact details",
        },
        {
            id: `SF1-18`,
            question: "Date of exchange",
        },
        {
            id: `SF1-19`,
            question: "Date of settlement",
        },
        {
            id: `SF1-20`,
            question: "Identification of Vendor/Purchaser Checklist completed",
        },
        {
            id: `SF1-21`,
            question: "Are there any instances of non-compliance?",
        },
        {
            id: "detailsOfNonComplianceSF1",
            question: "Details of non-compliance (if relevant):",
            type : "longtext"
        },
    ],


    "SALES FILE #2" : [
        {
            id: `SF2-1`,
            question: "File number",
        },
        {
            id: `SF2-2`,
            question: "Vendor's name",
        },
        {
            id: `SF2-3`,
            question: "Vendor's contact details",
        },
        {
            id: `SF2-4`,
            question: "Property sold",
        },
        {
            id: `SF2-5`,
            question: "Copy of Agency Agreement",
        },
        {
            id: `SF2-6`,
            question: "Start date of Agency Agreement",
        },
        {
            id: `SF2-7`,
            question: "Expiry date of Agency Agreement",
        },
        {
            id: `SF2-8`,
            question: "Additional listing records (if required)",
        },
        {
            id: `SF2-9`,
            question: "Estimated Selling Price (including Estimated Selling Price Checklist and relevant information in support)",
        },
        {
            id: `SF2-10`,
            question: "Revised Estimated Selling Price (if reviewed)",
        },
        {
            id: `SF2-11`,
            question: "Any Vendor instructions not to disclose the Estimated Selling Price",
        },
        {
            id: `SF2-12`,
            question: "Weekly Vendor report (or as agreed by vendor)",
        },
        {
            id: `SF2-13`,
            question: "Relevant correspondence",
        },
        {
            id: `SF2-14`,
            question: "Price statements (verbally or in writing) made to prospective Purchasers",
        },
        {
            id: `SF2-15`,
            question: "Approved marketing and advertisements (including the Adverting and Marketing Checklist)",
        },
        {
            id: `SF2-16`,
            question: "Purchaser's name",
        },
        {
            id: `SF2-17`,
            question: "Purchaser's contact details",
        },
        {
            id: `SF2-18`,
            question: "Date of exchange",
        },
        {
            id: `SF2-19`,
            question: "Date of settlement",
        },
        {
            id: `SF2-20`,
            question: "Identification of Vendor/Purchaser Checklist completed",
        },
        {
            id: `SF2-21`,
            question: "Are there any instances of non-compliance?",
        },
        {
            id: "detailsOfNonComplianceSF2",
            question: "Details of non-compliance (if relevant):",
            type : "longtext"
        },
    ],

    "SALES FILE #3" : [
        {
            id: `SF3-1`,
            question: "File number",
        },
        {
            id: `SF3-2`,
            question: "Vendor's name",
        },
        {
            id: `SF3-3`,
            question: "Vendor's contact details",
        },
        {
            id: `SF3-4`,
            question: "Property sold",
        },
        {
            id: `SF3-5`,
            question: "Copy of Agency Agreement",
        },
        {
            id: `SF3-6`,
            question: "Start date of Agency Agreement",
        },
        {
            id: `SF3-7`,
            question: "Expiry date of Agency Agreement",
        },
        {
            id: `SF3-8`,
            question: "Additional listing records (if required)",
        },
        {
            id: `SF3-9`,
            question: "Estimated Selling Price (including Estimated Selling Price Checklist and relevant information in support)",
        },
        {
            id: `SF3-10`,
            question: "Revised Estimated Selling Price (if reviewed)",
        },
        {
            id: `SF3-11`,
            question: "Any Vendor instructions not to disclose the Estimated Selling Price",
        },
        {
            id: `SF3-12`,
            question: "Weekly Vendor report (or as agreed by vendor)",
        },
        {
            id: `SF3-13`,
            question: "Relevant correspondence",
        },
        {
            id: `SF3-14`,
            question: "Price statements (verbally or in writing) made to prospective Purchasers",
        },
        {
            id: `SF3-15`,
            question: "Approved marketing and advertisements (including the Adverting and Marketing Checklist)",
        },
        {
            id: `SF3-16`,
            question: "Purchaser's name",
        },
        {
            id: `SF3-17`,
            question: "Purchaser's contact details",
        },
        {
            id: `SF3-18`,
            question: "Date of exchange",
        },
        {
            id: `SF3-19`,
            question: "Date of settlement",
        },
        {
            id: `SF3-20`,
            question: "Identification of Vendor/Purchaser Checklist completed",
        },
        {
            id: `SF3-21`,
            question: "Are there any instances of non-compliance?",
        },
        {
            id: "detailsOfNonComplianceSF3",
            question: "Details of non-compliance (if relevant):",
            type : "longtext"
        },
    ],

    "Property management transactions": [
        {
            id: "PMF",
            question: "Does every property under management have a separate file?",
        },
    ],

    "PROPERTY MANAGEMENT FILE #1" : [
        {
            id: `PMF1-1`,
            question: "File number",
        },
        {
            id: `PMF1-2`,
            question: "Landlord's name",
        },
        {
            id: `PMF1-3`,
            question: "Landlord's contact details",
        },
        {
            id: `PMF1-4`,
            question: "Landlord's contact details for inclusion in the Residential Tenancy Agreement?",
        },
        {
            id: `PMF1-5`,
            question: "Property leased",
        },
        {
            id: `PMF1-6`,
            question: "Copy of Agency Agreement",
        },
        {
            id: `PMF1-7`,
            question: "Start date of Agency Agreement",
        },
        {
            id: `PMF1-8`,
            question: "Expiry date of Agency Agreement",
        },
        {
            id: `PMF1-9`,
            question: "Verified banking details",
        },
        {
            id: `PMF1-10`,
            question: "Date each tenancy was entered into",
        },
        {
            id: `PMF1-11`,
            question: "Copy of an Ingoing inspection report.",
        },
        {
            id: `PMF1-12`,
            question: "Has the Bond been lodged.?",
        },
        {
            id: `PMF1-13`,
            question: "Are there any instances of non-compliance?",
        },
        {
            id: "detailsOfNonCompliancePMF1",
            question: "Details of non-compliance (if relevant):",
            type : "longtext"
        },
    ],

    "PROPERTY MANAGEMENT FILE #2" : [
        {
            id: `PMF2-1`,
            question: "File number",
        },
        {
            id: `PMF2-2`,
            question: "Landlord's name",
        },
        {
            id: `PMF2-3`,
            question: "Landlord's contact details",
        },
        {
            id: `PMF2-4`,
            question: "Landlord's contact details for inclusion in the Residential Tenancy Agreement?",
        },
        {
            id: `PMF2-5`,
            question: "Property leased",
        },
        {
            id: `PMF2-6`,
            question: "Copy of Agency Agreement",
        },
        {
            id: `PMF2-7`,
            question: "Start date of Agency Agreement",
        },
        {
            id: `PMF2-8`,
            question: "Expiry date of Agency Agreement",
        },
        {
            id: `PMF2-9`,
            question: "Verified banking details",
        },
        {
            id: `PMF2-10`,
            question: "Date each tenancy was entered into",
        },
        {
            id: `PMF2-11`,
            question: "Copy of an Ingoing inspection report.",
        },
        {
            id: `PMF2-12`,
            question: "Has the Bond been lodged.?",
        },
        {
            id: `PMF2-13`,
            question: "Are there any instances of non-compliance?",
        },
        {
            id: "detailsOfNonCompliancePMF2",
            question: "Details of non-compliance (if relevant):",
            type : "longtext"
        },
    ],

    "PROPERTY MANAGEMENT FILE #3" : [
        {
            id: `PMF3-1`,
            question: "File number",
        },
        {
            id: `PMF3-2`,
            question: "Landlord's name",
        },
        {
            id: `PMF3-3`,
            question: "Landlord's contact details",
        },
        {
            id: `PMF3-4`,
            question: "Landlord's contact details for inclusion in the Residential Tenancy Agreement?",
        },
        {
            id: `PMF3-5`,
            question: "Property leased",
        },
        {
            id: `PMF3-6`,
            question: "Copy of Agency Agreement",
        },
        {
            id: `PMF3-7`,
            question: "Start date of Agency Agreement",
        },
        {
            id: `PMF3-8`,
            question: "Expiry date of Agency Agreement",
        },
        {
            id: `PMF3-9`,
            question: "Verified banking details",
        },
        {
            id: `PMF3-10`,
            question: "Date each tenancy was entered into",
        },
        {
            id: `PMF3-11`,
            question: "Copy of an Ingoing inspection report.",
        },
        {
            id: `PMF3-12`,
            question: "Has the Bond been lodged.?",
        },
        {
            id: `PMF3-13`,
            question: "Are there any instances of non-compliance?",
        },
        {
            id: "detailsOfNonCompliancePMF3",
            question: "Details of non-compliance (if relevant):",
            type : "longtext"
        },
    ],

    "Trust Accounts transactions (review last 3 x P.M end of month documents)" : [
        {
            id: "TAT-1",
            question: "Cash transactions reconciled against cash book entries",
        },
        {
            id: "TAT-2",
            question: "Confirm Licensee-in-charge authority for three random withdrawals",
        },
        {
            id: "TAT-3",
            question: "Review monthly trial balance for accuracy",
        },
        {
            id: "TAT-4",
            question: "Confirm Landlord Funds Withhold Requests received for all landlord accounts with a retained balance If applicable for chosen months.",
        },
        {
            id: "TAT-5",
            question: "Review monthly bank reconciliation to confirm it is in balance",
        },
        {
            id: "TAT-6",
            question: "Review source documents to explain any adjustments or reversals on the bank reconciliation",
        },
        {
            id: "TAT-7",
            question: "Any change of bank account details have been verified?",
        },
    ],
};
